import React from 'react'
import { Form, Field, reduxForm } from 'redux-form'
import RenderFormField from 'components/render-form-field'
import { requiredField, usernameEmailCheck } from 'util/field-validation'
import striptags from 'striptags'
import SubmitButton from 'components/buttons/submit-button'

const LoginForm = ({ submitting, loading, error, handleSubmit }) => {
  const submitDisabled = submitting || loading

  const formError = error ? (
    <div
      className='form--error'
      data-ext='form--error-login'
      dangerouslySetInnerHTML={{ __html: striptags(error, ['a']) }}
    />
  ) : null

  return (
    <Form
      id='ext--login-form'
      data-test-key='login-form'
      className='form'
      method='POST'
      noValidate='novalidate'
      onSubmit={handleSubmit}
    >
      <Field
        name='username'
        placeholder='Username'
        component={RenderFormField}
        type='text'
        validate={requiredField}
        autoFocus
      />
      <Field
        name='password'
        placeholder='Password'
        component={RenderFormField}
        type='password'
        validate={requiredField}
      />

      {formError}

      <div className='form-group'>
        <SubmitButton
          text='Sign in'
          loading={submitDisabled}
          disabled={submitDisabled}
          testKey='login-submit'
        />
      </div>
    </Form>
  )
}

export default reduxForm({
  form: 'login',
  destroyOnUnmount: true,
  touchOnBlur: false,
  touchOnChange: true,
})(LoginForm)
